/**
 * Getter for get appointment module
 */
export const getters = {
  getYearsQueried(state) {
    return state.yearsAlreadyQueried;
  },
  getAppointmentDates(state) {
    return state.appointmentDates;
  },
  getSelectedYear(state) {
    return state.selectedYear;
  },
  getSelectedMonth(state) {
    return state.selectedMonth;
  },
  getSelectedDayOfMonth(state) {
    return state.selectedDayOfMonth;
  },
  getSelectedWeek(state) {
    return state.selectedWeek;
  },
  getWeekMonth(state) {
    return state.selectedWeekMonth;
  },
  getWeekYear(state) {
    return state.selectedWeekYear;
  },
  getCoordinates(state) {
    return state.monthCoordinates;
  },
  getAllAppointments(state) {
    return state.appointments;
  },
  getAlreadyQueriedDates(state) {
    return state.appointmentDatesAlreadyQueried;
  },
  getShowWeeks(state) {
    return state.showWeeks;
  },
  getClientNameFormat(state) {
    return state.clientNameFormat;
  },
  getClientNameOrder(state) {
    return state.clientNameOrder;
  },
  getLoadingGetAppointment(state) {
    return state.loadingGetAppointment;
  },
  getShowSplitScreenMonthly(state) {
    return state.showSplitScreenMonthly;
  }
};
